import { useGetQuery } from './useGetQuery';

interface AccountLookupParams {
    bankCode: string;
    accountNumber: string;
    enabled: boolean;
}

interface AccountLookupResponse {
    accountNumber: string;
    accountName: string;
}

export const useBankAccountLookup = (params: AccountLookupParams) => {
    const { bankCode, accountNumber, enabled = true } = params;

    const { isFetching, entries, error } = useGetQuery<AccountLookupResponse>({
        url: '/banks/account/lookup',
        cacheKey: `account-${bankCode}-${accountNumber}`,
        params: { bankCode, accountNumber },
        enabled
    });
    

    return {
        isFetching,
        accountNumber: entries?.accountNumber ?? '',
        accountName: entries?.accountName ?? '',
        rawResponse: entries,
        error: error
    };
};
